import {createStore} from 'vuex'

import { state } from '@/vuex/state'
import { getters } from '@/vuex/getters'
import * as actions from '@/vuex/actions'
import { mutations } from '@/vuex/mutations'

import geo from './geo'
import user from './user'
import project from './project'
import org from './org'
import billing from './billing'
import search from './search'
import layers from './layers'
import maps from './maps'
import split from './split'
import report from './report'
import notifications from './notifications'
import boundary from './boundary'
import monitoring from './monitoring'
import chat from './chat'
import discussion from './discussion'
import messaging from './messaging'

const store = createStore({
  modules: {
    user,
    project,
    geo,
    org,
    billing,
    search,
    layers,
    maps,
    split,
    report,
    notifications,
    boundary,
    monitoring,
    chat,
    discussion,
    messaging
  },
  state,
  actions,
  mutations,
  getters,
  plugins: []
})


export default store
